/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components'
import ChevronRightIcon from '../img/icons/chevron-right.svg'

export const FormCSS = css`
  position: relative;

  & .form-duuf-group {
    position: relative;
    margin-bottom: 1.5rem;
  }

  & .form-duuf-textarea {
    border: 1px solid ${(props) => props.theme.color.grey};
    width: 90%;
    font-size: 16px;
    height: 145px;
    text-indent: 15px;
    font-style: italic;
    padding-top: 10px;

    @media (max-width: 991.98px) {
      width: 100%;
    }
  }
  & .form-duuf-input {
    border: 1px solid ${(props) => props.theme.color.grey};
    text-indent: 10px;
    width: 90%;
    height: 41px;
    font-size: 16px;
    text-indent: 15px;
    font-style: italic;

    @media (max-width: 991.98px) {
      width: 100%;
    }
  }

  & .form-duuf-textarea {
    height: 150px;
  }

  & .form-duuf-file-name {
    margin-left: 0.5rem;
  }

  & .form-duuf-checkbox-consent {
    color: ${({ theme }) => theme.color.light};
  }

  & .form-duuf-group-consent {
    color: ${({ theme }) => theme.color.light};

    & a {
      margin-left: 0;

      &:hover {
        color: ${({ theme }) => theme.color.light};
        text-decoration: underline;
      }
    }

    & span {
      padding-left: 0.5rem;
    }

    & .form-duuf-error {
      color: red;
      position: relative;
      top: 0;
      right: 0;
    }
  }

  & .form-duuf-checkbox-label {
    margin-left: 0.5rem;
    margin-bottom: 0;
  }

  & .form-duuf-label {
    font-style: italic;
    color: ${(props) => props.theme.color.text.contrast};
    margin-bottom: 0.5rem !important;

    @media (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xm};
    }

    @media (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.m};
    }
  }

  & .form-duuf-label-mandatory {
    font-size: ${(props) => props.theme.font.size.xm};
    color: ${(props) => props.theme.color.contrast};
    margin-left: 5px;
  }

  & .form-duuf-error {
    color: red;
    position: absolute;
    right: 35px;
    bottom: -22px;
    font-size: 14px;
  }

  & .form-duuf-submit {
    float: right;
    margin-right: 10%;
    margin-top: 3rem;

    display: inline-block;
    position: relative;
    font-size: 20px;
    font-weight: 300;
    transition: transform 0.25s ease 0s;

    &:hover {
      transform: scale(1.05);
    }

    &::after {
      position: absolute;
      content: '';
      width: 0px;
      height: 0px;
      border-top: 1rem solid transparent;
      border-right: 1rem solid transparent;
      background: transparent;
      right: 0px;
      bottom: 0px;
      z-index: 2;
    }

    & > a,
    & > button {
      text-decoration: unset;
      background-color: ${(props) => props.theme.color.contrast};
      color: ${(props) => props.theme.color.text.secondary};
      padding: 10px 15px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 0;
      position: relative;

      &::after {
        content: '';
        display: block;
        background-image: url(${ChevronRightIcon});
        background-size: contain;
        width: 14px;
        height: 18px;
        background-repeat: no-repeat;
        margin-left: 20px;
        margin-right: 5px;
      }

      &:hover {
      }
    }

    ${(props) =>
      props.black &&
      css`
        & > a,
        & > button {
          background: ${props.theme.color.main};
          color: #fff;
        }
      `}

    ${(props) =>
      props.back &&
      css`
        &::after {
          //border-top: 16.5px solid transparent;
          border-top: 1rem solid transparent;
          border-right: unset;
          border-left: 1rem solid #fff;
          background: transparent;
          left: 0;
          bottom: 0;
          z-index: 2;
        }

        & > a,
        & > button {
          padding-left: 0 !important;
          padding-right: 15px !important;

          &::before {
            content: '';
            display: block;
            background-image: url(${ChevronRightIcon});
            background-size: contain;
            width: 14px;
            height: 18px;
            background-repeat: no-repeat;
            margin-left: 5px;
            margin-right: 20px;
            transform: rotate(180deg);
          }

          &::after {
            display: none;
          }
        }
      `}

    &-disabled {
      opacity: 0.5;
    }
  }

  & .form-duuf-confirm {
    color: ${({ theme }) => theme.color.light};
    font-size: 30px;
    line-height: 40px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }

  & .form-duuf-something-wrong {
    color: red;
  }

  & .form-duuf-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.5);
  }

  & .form-duuf-file-input {
    display: block !important;
  }
`
